import {Component} from '@angular/core';

@Component({
    selector: 'vui-data-grid-actions',
    templateUrl: './data-grid-actions.component.html',
    styleUrls: ['./data-grid-actions.component.scss']
})
export class DataGridActionsComponent {

}
